<template>
  <div class="text-center" style="padding: 16px;">
    <div>
      <p class="custom-mb-4 mt-0">
        {{ $t("slideQRCodeAudience") }}
      </p>

      <div class="div-image-qrcode">
        <img :src="img" alt="" v-if="img">
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Config from '@/config'
import { mapGetters, mapState } from 'vuex'
import joinPresentationUtils from '@/utils/join-presentation.utils'

export default {
  data() {
    return {
      img: '',
    }
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      audienceName: (state) => state.audienceName,
      audienceEmoji: (state) => state.audienceEmoji,
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      chosenTeam: (state) => {
        return state.presentation.teamData ?
          state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) : {}
      },
    }),
    textColour() {
      return this.slide.textColour
    },
    hasQuizSlides() {
      return this.$store.state.slides &&
          this.$store.state.slides.length > 0 &&
          this.$store.state.slides.some((slide) => slide.type === 'pickAnswer')
    },
  },
  mounted() {
    const text =
      `${Config.audienceUrl}/${this.$store.state.presentation.uniqueAccessCode}`
    const self = this
    QRCode.toDataURL(
      text,
      { errorCorrectionLevel: 'Q', width: 800, margin: 1 },
      (err, url) => {
        self.img = url
      },
    )
    this._joinGame()
  },
  methods: {
    _joinGame() {
      if (this.hasQuizSlides && this.audienceName) {
        this.$http
          .post(joinPresentationUtils.getApiUrlJoinPresentation(), {
            a: this.audienceId,
            n: this.audienceName,
            e: this.audienceEmoji,
            c: this.presentation.uniqueAccessCode,
            i: this.slide.id,
            t: this.audienceQuizTeam,
          })
          .then(
            () => {},
            () => {},
          )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  font-size: 18px;
}

.div-image-qrcode {
  max-width: 30%;
  margin: 0 auto 16px auto;
}
img {
  max-width: 100%;
  width: 100%;
}

@media (max-width: 800px) {
  .div-image-qrcode {
    max-width: 30%;
  }
}
</style>
